export const EXTERNAL_REPORT_TYPE = 'hokkaido-airport';
export const EXTERNAL_REPORT_CONTENTS_OTHER = 'その他';
export const MAX_SAVABLE_PHOTOS_COUNT = 50;
export const MAX_PENDING_PHOTOS_COUNT = 8;
// 業務開始・作業開始・作業終了・業務終了の時刻を丸める単位
export const REPORT_TS_ROUND_MINUTES = 5;
// 初期画面でログアウトした場合、業務開始時刻を localStorage から読み込むが、古い時刻は無効にするための期限
export const DEPARTURE_STORAGE_EXPIRE_HOURS = 1;

export const NO_PHOTO_IMAGE = 'data:image/svg+xml;utf8,' +
  encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" width="640" height="480">
      <rect width="100%" height="100%" fill="#f0f0f0"/>
      <text x="50%" y="50%" text-anchor="middle" dominant-baseline="middle"
        font-size="100" fill="#666" font-family="sans-serif">写真なし</text>
    </svg>
  `);
